import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { Stars } from "./Stars";

let cache = null;
const load = () => (cache = cache || axios.get(`${API}/toolkit-ratings`).then((r) => r.data).catch(() => ({})));

export const useToolkitRatings = () => {
  const [data, setData] = useState({});
  useEffect(() => { load().then(setData); }, []);
  return data;
};

export const RatingBadge = ({ shopId, showQuote = true }) => {
  const r = useToolkitRatings()[shopId];
  if (!r) return null;
  return (
    <div className="mb-3" data-testid={`rating-${shopId}`}>
      <div className="flex items-center gap-2">
        <Stars value={Math.round(r.avg)} size={12} testid={`rating-stars-${shopId}`} />
        <span className="text-xs text-neutral-400">{r.avg.toFixed(1)} · {r.count} rating{r.count === 1 ? "" : "s"}</span>
      </div>
      {showQuote && r.quote && (
        <p className="text-xs italic text-neutral-400 mt-1.5 line-clamp-2" data-testid={`rating-quote-${shopId}`}>
          "{r.quote.text}" <span className="not-italic text-neutral-500">— {r.quote.name}</span>
        </p>
      )}
    </div>
  );
};
